/* src/app/master-data/business-units/business-units-list/business-units-list.component.css */
/*# sourceMappingURL=business-units-list.component-EVRFOR2G.css.map */
